module.exports = __webpack_public_path__ + "static/media/deleteUserTrashIcon.c161ccd0.svg";